import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';

class ColorPicker extends Component {
    constructor(props){
        super(props);

        this.state = {
            color: '#000000',
            isOpen: false
        }

        this.onColorChanged = this.onColorChanged.bind(this);
        this.toggleColorPicker = this.toggleColorPicker.bind(this);
    }

    componentDidMount(){
        const {color} = this.props;

        if(color){
            this.onColorChanged({hex: color});
        } 
    }


    onColorChanged(color){
        const {name, onChange} = this.props;

        onChange(color.hex)

        this.setState({
            color: color.hex
        })

    }

    toggleColorPicker(){
        const {name} = this.props;

        this.setState({
            ...this.state,
            isOpen: !this.state.isOpen
        })
    }
/*
    shouldComponentUpdate(nextProps, nextState){
        return this.state.isOpen !== nextState.isOpen || this.state.color !== nextState.color;
    }
*/
    render(){
        let {label, color}= this.props;

        if (color !== this.state.color){
            this.onColorChanged({hex: color});
        }
        
        let textColor={
            width: '28px',
            height: '28px',
            backgroundColor: this.state.color,
            borderRadius: '50%',
            display: 'inline-block',
            position: 'relative',
            border: '2px solid #cccccc'
        }

        let colorPicker={
            position: 'absolute',
            // top:'0',
            // left:'0',
            display: this.state.isOpen? 'block': 'none',
            zIndex: '99999999',
            backgroundColor: 'white',
           
            padding: '10px',
            margin: '-10px',
            borderRadius: '4px',    
        }

        let containerStyle= {
            display: 'table',
            height:'36px',
            marginBottom: '5px',
            cursor: 'pointer'
        }

        let valignStyle= {
            display: 'table-cell',
            verticalAlign: 'middle',
            textAlign: 'center',
            fontSize: '12px'
        } 
        let labelStyle = {
            display: 'inline-block',
            marginRight: '5px',
            height: '28px',
            fontWeight: 'bold'  
        }
        return (
                <div style={containerStyle}>
                    <div style={valignStyle}>
                        <span style={labelStyle}>{label}</span>
                        </div>
                    <div style={valignStyle}>
                    <style dangerouslySetInnerHTML={{__html: `
                                .color-picker-text:hover{
                                    border: 2px solid #4c397c !important;
                                }
                            `}}></style>
                        <div style={textColor} className="color-picker-text" onClick={this.toggleColorPicker}>
                        </div>     
                            <div style={colorPicker}>
                                <div style={{textAlign:'right'}} onClick={this.toggleColorPicker}>
                                    <span dangerouslySetInnerHTML={{__html: "&#10006;"}}>
                                    </span>
                                </div>
                                <SketchPicker color={this.state.color} onChangeComplete={this.onColorChanged} />
                            </div>
                            <p onClick={this.toggleColorPicker}>{`${this.state.color}`.toLowerCase()}</p>

                    </div>
                </div>
        );
    }
}

ColorPicker.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default ColorPicker;


// WEBPACK FOOTER //
// app/components/ColorPicker.jsx